import { createFileRoute, redirect } from '@tanstack/react-router'
import { PageLoader } from '@trellis/roots/loading'
import { Typography } from '@trellis/roots/typography'

import { authClient } from '@/lib/auth-client'
import { DashboardPage } from '@/pages/dashboard/DashboardPage'

interface AuthenticatedUser {
  isSystemAdmin?: boolean
  twoFactorEnabled?: boolean
}

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async () => {
    const { data: session } = await authClient.getSession()

    if (!session) {
      throw redirect({ to: '/login' })
    }

    /* better-auth returns additionalFields at runtime but doesn't type them on the client */
    const user = session.user as AuthenticatedUser

    /*
     * The backend rejects every API call from a system admin without 2FA, so send them to
     * enrolment before any page loads. Non-admins fall through to the access-restricted
     * message below.
     */
    if (user.isSystemAdmin && !user.twoFactorEnabled) {
      throw redirect({ to: '/2fa-setup' })
    }

    return { user }
  },
  pendingComponent: PageLoader,
  component: AuthenticatedLayout,
})

function AuthenticatedLayout() {
  const { user } = Route.useRouteContext()

  if (!user.isSystemAdmin) {
    return (
      <div className="flex h-screen flex-col items-center justify-center gap-2">
        <Typography variant="body" color="muted">
          Access restricted to system administrators.
        </Typography>
      </div>
    )
  }

  return <DashboardPage />
}
